import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from "react-router-dom";
import { actionCreators } from "../../store/WorkOrder";
import {bindActionCreators} from "redux";
import * as d3 from 'd3';
import {mapStateToProps} from "./KPISettingsMenu";

class KPILegend extends Component{
  constructor(props) {
    super(props);
    
    this.state = {
        data: []
    };
    
    this.onClick = this.onClick.bind(this);
  }
  
  componentDidMount() {
    this.setState({
      data: this.props.data,
        colors: this.createColors()
      })
  }

  createColors() {
    return d3
      .scaleOrdinal()
      .domain(this.state.data.map(d => d.name))
      .range(this.props.colorRange);
  }

onClick(event) {
    if (event.currentTarget.getAttribute("toquote") == 'true') {
        if (event.currentTarget.getAttribute("name") == "Rejected") {
            this.props.history.push('/quotes', { kpiSearch: 'rejected'})
        }
        if (event.currentTarget.getAttribute("name") == "Pending Approval") {
            this.props.history.push('/quotes', { kpiSearch: 'open' })
        }
    }
    else {
        const query = event.currentTarget.getAttribute("id");
        this.props.setQuery(query);
        this.props.history.push("/services");
    }
    
  }
  
  render() {
    const { data, colors} = this.state;
    
    if (!data || !colors) {
      return <div> Loading... </div>;  
    } 
    
    return(
      <div>
        {data.map((kpi) => {
            var temp;
            kpi.toQuote ? temp = 'true' : temp = 'false'    
            return (
            <div className="flex-row kpi-item" 
                 key={kpi.id} 
                 id={kpi.id}
                 name={kpi.name}
                 toquote={temp}
                 style={{backgroundColor: colors(kpi.name)}} 
                 onClick={kpi.noClick ? null : this.onClick}>
              <div className="kpi-sub-item">
                <p style={{color: '#fff'}}>{kpi.name}</p>
              </div>
              <div className="kpi-sub-item">
                <p style={{color: '#fff'}}>{kpi.count}</p>
              </div>
            </div>
          )
        })}
      </div>
    )
    
  }
}

export default connect(
  mapStateToProps,
  dispatch => bindActionCreators(actionCreators, dispatch)
)(KPILegend);